class BroadcastChannelMock {
	postMessage(message: any) {
		console.log("Broadcasting message", message);
	}
}
export const BroadcastChannelClass = window.BroadcastChannel || BroadcastChannelMock;
